export default {
    props: {
      subContainer:{
        type: Boolean,
        default: false,
      },
      containerxl:{
        type: Boolean,
        default: false,
      },
      containerxxl:{
        type: Boolean,
        default: false,
      },
      containermd:{
        type: Boolean,
        default: false,
      },
      containersm:{
        type: Boolean,
        default: false,
      },
      dynamicbodyxl:{
        type: Boolean,
        default: false,
      },
      bodyxl: {
        type: Boolean,
        default: false,
      },
      bodymd: {
        type: Boolean,
        default: false,
      },
      widthMd:{
        type: Boolean,
        default: false,
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
      footerShow:{
        type: Boolean,
        default: false,
      },
      hideClose:{
        type: Boolean,
        default: false,
      },
      subHeaderPart:{
        type: Boolean,
        default: false,
      },
      positionRelative:{
        type: Boolean,
        default: false,
      },
    },
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },
      closeSubModal() {
        this.$emit('closeSubModal');
      }
    }
  };
  